import React, { useState } from "react";
import { useSelector } from "react-redux";
import { EditListIcon } from "../../../../assets/images/svg/svg";
import {
    editModal,
    openModal,
} from "../../../../slices/common/reducer";
import { setEditData } from "../../../../slices/qualification/qualificationsSlice";
import rootReducer from "../../../../store";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const useQualificationColumns = () => {
    const [showEditBtn, setEditBtn] = useState(
        checkButtonAccess("EDIT", "SETN_QUAL")
    );

    const qualificationColumns = [
        {
            header: "Qualification",
            accessorKey: "qualification",
            cell: (props) => (props?.getValue() ? props.getValue() : "-"),
            size: 250,
        },
        {
            header: "Category",
            accessorKey: "doctor_category",
            cell: (props) => (props?.getValue() ? props.getValue() : "-"),
            size: 250,
        },
        {
            header: "AG",
            accessorKey: "ag_name",
            cell: (props) => (props?.getValue() ? props.getValue() : "-"),
            size: 250,
        },
        {
            header: "",
            accessorKey: "action",
            cell: (props) =>
                showEditBtn ? (
                    <div className="d-flex justify-content-end w-100 pe-3">
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                rootReducer.dispatch(setEditData(props.row.original));
                                rootReducer.dispatch(openModal(true));
                                rootReducer.dispatch(editModal(true));
                            }}
                        >
                            <EditListIcon />
                        </div>
                    </div>
                ) : (
                    ""
                ),
            size: 50,
        },
    ];

    return { qualificationColumns };
};

export default useQualificationColumns;